import { Box, Button, Typography } from "@mui/material";
import { COLORS } from "assets";
import { RTSPSources } from "types";

export interface ConnectionTypeOption {
  value: RTSPSources;
  label: string;
}

export interface ConnectionTypeSelectProps {
  value: RTSPSources;
  onChange: (value: RTSPSources) => void;
  label?: string;
  options: ConnectionTypeOption[];
}

export default function ConnectionTypeSelect({ value, onChange, label, options }: ConnectionTypeSelectProps) {
  return (
    <Box>
      {label ? (
        <Typography sx={{ color: COLORS.surface.primaryText, fontWeight: 600, fontSize: 14, mb: 1.25 }}>
          {label}
        </Typography>
      ) : null}
      <Box display="flex" gap={1} flexWrap="wrap">
        {options.map((opt) => {
          const selected = value === opt.value;
          return (
            <Button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 0" },
                minWidth: 0,
                height: 40,
                px: 1.5,
                borderRadius: `${COLORS.radius.md}px`,
                border: `1px solid ${selected ? COLORS.primary : COLORS.surface.border}`,
                bgcolor: selected ? "rgba(30, 152, 217, 0.06)" : COLORS.surface.card,
                color: selected ? COLORS.primary : COLORS.surface.secondaryText,
                fontWeight: 500,
                fontSize: 13,
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: selected ? "rgba(30, 152, 217, 0.1)" : COLORS.surface.tableHeader,
                  borderColor: selected ? COLORS.primary : COLORS.surface.secondaryText,
                  boxShadow: "none"
                }
              }}
            >
              {opt.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
